export type ChatMensagemDtoEstado =
  | "em_processamento"
  | "processada"
  | "lida"
  | "erro";

/**
 * Estados que representam uma mensagem efetivamente entregue.
 * Telas que só querem mensagens entregues (ex.: supervisão de IA, histórico do
 * cliente) enviam este conjunto como filtro — o endpoint /chat_mensagem não impõe
 * restrição de estado por padrão.
 */
export const ESTADOS_MENSAGEM_ENTREGUE: ChatMensagemDtoEstado[] = ["processada", "lida"];

export type ChatMensagemDto = {
  id?: number;
  uuid?: string;
  chat?: any;
  chat_id?: number;
  data: string;
  nome: string;
  tipo_mime: string;
  conteudo_ou_url: string;
  origem: "bot" | "atendente" | "usuario" | "sistema";
  opcoes?: any[];
  metadados?: Record<string, any>;
  data_criacao?: string;
  estado_atual?: ChatMensagemDtoEstado;
  descricao_estado_atual?: string;
};
